'use client'

import { useTranslations } from 'next-intl'

import S from '../../../moderation/ClubModeration.module.scss'

type BlockedClubProfileHeaderProps = {
  clubName: string
}

export function BlockedClubProfileHeader({
  clubName
}: BlockedClubProfileHeaderProps) {
  const t = useTranslations('club.blockedProfile')

  return (
    <div className={S.headerBlock}>
      <div className={S.textBlock}>
        <h1 className={S.greeting}>{t('greeting', { name: clubName })}</h1>
        <p className={S.subtitle}>{t('subtitle')}</p>
      </div>
      <div className={S.badges}>
        <span className={S.badge}>
          <span className={S.badgeLabel}>{t('statusLabel')}</span>
          <span className={`${S.badgeValue} ${S.badgeValueRejected}`}>
            {t('statusBlocked')}
          </span>
        </span>
      </div>
    </div>
  )
}
